var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item",class:_vm.itemClass},[(_vm.item.type === 'question' && _vm.editable)?_c('Icon',{attrs:{"name":"drag_indicator"}}):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.itemTitle)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }